import React, { Component } from 'react';
import { Layout, Col, Row, Form, Input, Button, Alert, Typography, Spin, Space } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import api from '../lib/api'
import '../App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import { showSuccess } from '../utils/Notifications';

// const axios = require('axios').default;

class Forget extends Component {

  constructor(props) {

    super(props);

    this.state = {
      loading: true,
      loginError: false,
      loginLoading: false,
      identity: this.props.identity || null,
      choices: null,       // occupant must pick between two homes
      baseValues: null,
    };
  }

  componentDidMount() {
    localStorage.clear();
  }

  reset = (values) => {
    this.setState({loginError: false, loginLoading:true});
    this.submit(values);
  }

  // A zipcode + house number can match two homes ("21" = house 21 or house 2-1).
  // The backend then returns action:'choose-address' and we let the occupant pick.
  submit = (values) => {
    var apiParams = this.props.occupant
      ? {'zipcode': values.zipcode, 'house_number': values.house_number, 'chosen_house_number': values.chosen_house_number, 'chosen_house_number_suffix': values.chosen_house_number_suffix }
      : {'email': values.username };

    var apiUrl = this.props.occupant ? 'public/forgot-password' : 'auth/forget';

    api('post', apiUrl, apiParams, false).then((response) => {
      this.setState({loginLoading:false});

      if(response && response.data && response.data.action === 'choose-address') {
        this.setState({ choices: response.data.addresses, baseValues: values });
        return;
      }

      this.setState({ choices: null, baseValues: null });
      showSuccess('Wachtwoord verzonden');
    });
  }

  chooseAddress = (choice) => {
    this.submit({
      ...this.state.baseValues,
      chosen_house_number: choice.house_number,
      chosen_house_number_suffix: choice.house_number_suffix,
    });
  }

  render() {    

    const { Title, Paragraph } = Typography;

    // const { getFieldDecorator } = this.props.form;

    return (
      <Row type="flex" style={{ height: "100%", flexDirection: "column", justifyContent: "space-between"}}>

        <Col>
          <img style={{width: 200, marginBottom: 48}} src={this.state.identity.logo_url} />
        </Col>

        <Col>

          <div>

            {this.state.choices ?
            <div>
              <Title level={2}>Welk adres is van u?</Title>
              <Paragraph>Kies uw exacte adres, inclusief toevoeging:</Paragraph>
              {this.state.choices.map((choice, i) => (
                <Button
                  key={i}
                  style={{ width: '100%', marginBottom: 8, height: 'auto', whiteSpace: 'normal', textAlign: 'left' }}
                  onClick={() => this.chooseAddress(choice)}
                >
                  {(choice.street ? choice.street + ' ' : '')}{choice.house_number}{choice.house_number_suffix ? '-' + choice.house_number_suffix : ''}
                </Button>
              ))}
              <span style={{ display: 'block', margin: '16px 0 0 0', cursor: 'pointer' }} onClick={() => this.setState({ choices: null, baseValues: null })}>Terug</span>
            </div>
            :
            <Form onFinish={this.reset} style={{ width: '100%', textAlign: 'middle', }}>

              <Title level={2}>Wachtwoord vergeten</Title>

              <Paragraph>Vul een gebruikersnaam in om een nieuw wachtwoord in te stellen.</Paragraph>

              { !this.props.occupant ? 
              <Form.Item 
                name="username"
                style={{ marginBottom: '8px' }} 
                rules={[{ required: true, message: 'Vul een gebruikersnaam in'}]}
              >
                <Input prefix={<UserOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />} placeholder="Gebruikersnaam" />
              </Form.Item>
              :
              <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                  <div style={{ flex: 1 }}>
                      {/*<Form.Item style={{ marginBottom: '8px' }}>
                          {getFieldDecorator('zipcode', {
                            onChange: (event) => { this.setState({ zipcode: this.filterZipcode(event.target.value) }, () => { this.props.form.setFieldsValue({'zipcode': this.state.zipcode}); }); },
                            rules: [{ required: true, message: 'Vul een postcode in' }],
                          })(
                              <Input prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Postcode" maxLength={6} />
                          )}
                      </Form.Item>*/}
                      <Form.Item 
                        name="zipcode"
                        style={{ marginBottom: '8px' }} 
                        rules={[{ required: true, message: 'Vul een postcode in'}]}
                        >
                        <Input prefix={<UserOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />} placeholder="Postcode" />
                      </Form.Item>
                  </div>
                  <div style={{ flex: 2 }}>
                      {/*<Form.Item style={{ marginBottom: '8px' }}>
                          {getFieldDecorator('house_number', {
                            onChange: (event) => { this.setState({ house_number: this.filterHouseNumber(event.target.value) }, () => { this.props.form.setFieldsValue({'house_number': this.state.house_number}); }); },
                            rules: [{ required: true, message: 'Vul een huisnummer + toevoeging in' }],
                          })(
                              <Input prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Huisnummer + toevoeging" />
                          )}
                      </Form.Item>*/}
                      <Form.Item 
                        name="house_number"
                        style={{ marginBottom: '8px' }} 
                        rules={[{ required: true, message: 'Vul een huisnummer (en eventueel toevoeging) in'}]}
                        >
                        <Input prefix={<UserOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />} placeholder="Huisnummer + toevoeging" />
                      </Form.Item>
                  </div>
              </div>}

              <Button style={{ width: '100%', margin: '16px 0 0 0' }} type="primary" htmlType="submit" loading={this.loginLoading}>Versturen</Button>
              {/* <Button style={{ width: '100%', color: 'black', margin: '16px 0 0 0', background: '#' + this.state.identity.color_primary, borderColor: '#' + this.state.identity.color_primary}} onClick={this.reset} type="primary">Inloggen</Button> */}
              {window.location.href.indexOf("beheer") > -1 
                ? (<Link to="/beheer"><span style={{ display: 'block', margin: '16px 0 0 0'}}>Terug naar inloggen</span></Link>)
                : (<Link to="/"><span style={{ display: 'block', margin: '16px 0 0 0'}}>Terug naar inloggen</span></Link>)
              }

            </Form>
            }

          </div>

        </Col>

      </Row>
    );

  }
}

export default Forget;

// const ForgetForm = Form.create({ name: 'login_forget' })(Forget);

// const mapStateToProps = (state, ownProps) => {
//   return {

//   };
// }

// const mapDispatchToProps = (dispatch) => {
//   return {

//   }
// };

// export default (ForgetForm);